import { render } from "./LegacyGroupDetailedAlarmReport.vue?vue&type=template&id=5772bd83"
import script from "./LegacyGroupDetailedAlarmReport.vue?vue&type=script&lang=js"
export * from "./LegacyGroupDetailedAlarmReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__